import i18n, { type ResourceKey } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { locales } from '@front/translations/constants/language'

export const i18nReady = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: 'backend',
    read(
      language: string,
      namespace: string,
      callback: (
        errorValue: unknown,
        translations: ResourceKey | boolean | null | undefined,
      ) => void,
    ) {
      import(`@front/locales/${language}/${namespace}.json`)
        .then((resources: unknown) => {
          callback(
            null,
            ((resources as { default: unknown })?.default ||
              resources) as ResourceKey,
          )
        })
        .catch((error) => {
          callback(error, null)
        })
    },
  })
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    supportedLngs: locales,
    ns: ['main.common', 'main.offers', 'common.jobs'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'sessionStorage', 'navigator'],
      caches: [],
    },
    load: 'languageOnly',
  })
